export const initShortcodeAccordions = () => {
  const accordions = document.querySelectorAll("[data-accordion]");

  accordions.forEach((accordion) => {
    if (accordion.closest(".elementor-widget-wfg-accordion")) return;

    const entries = accordion.querySelectorAll("[data-accordion-entry]");

    const closeAll = () => {
      entries.forEach((entry) => {
        const region = entry.querySelector<HTMLElement>('[role="region"]');
        const button = entry.querySelector('[role="button"]');
        const minus = button?.querySelector("[data-minus]") as HTMLElement;
        const plus = button?.querySelector("[data-plus]") as HTMLElement;

        if (region) {
          region.classList.remove("py-4");
          region.classList.add("overflow-hidden");
          region.style.height = "0";
        }
        button?.setAttribute("aria-expanded", "false");
        minus?.classList.add("hidden");
        plus?.classList.remove("hidden");
      });
    };

    entries.forEach((entry) => {
      const region = entry.querySelector<HTMLElement>('[role="region"]');
      const button = entry.querySelector('[role="button"]');
      const minus = button?.querySelector("[data-minus]") as HTMLElement;
      const plus = button?.querySelector("[data-plus]") as HTMLElement;

      button?.addEventListener("click", () => {
        if (button.getAttribute("aria-expanded") === "true") {
          closeAll();
          return;
        }

        closeAll();
        button.setAttribute("aria-expanded", "true");
        minus?.classList.remove("hidden");
        plus?.classList.add("hidden");
        if (region) {
          region.classList.add("py-4");
          region.style.height = `calc(${region.scrollHeight}px + 2rem)`;
        }
      });
    });
  });
};
